import React, { useState, useEffect } from 'react';
import { useAdminData } from '../useAdminData';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import './PraisesPage.css';

const DragHandleIcon = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    {...props}
  >
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
    <circle cx="5" cy="5" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
    <circle cx="5" cy="19" r="1"></circle>
  </svg>
);

const PraisesPage = () => {
    const { formData, isLoading, isSaving, success, handleFormChange, handleSave } = useAdminData();
    const [localPraises, setLocalPraises] = useState([]);

    useEffect(() => {
        if (formData?.praises) {
            const sorted = [...formData.praises].sort((a,b) => a.order - b.order);
            setLocalPraises(sorted);
        }
    }, [formData?.praises]);

    const onDragEnd = (result) => {
        if (!result.destination || result.destination.index === result.source.index) {
            return;
        }
        
        const items = Array.from(localPraises);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        
        const updatedItemsWithOrder = items.map((item, index) => ({ ...item, order: index + 1}));
        console.log(updatedItemsWithOrder);
        setLocalPraises(updatedItemsWithOrder);
    };

    const handleDelete = (idToDelete) => {
        if (!window.confirm("Biztosan törölni szeretnéd ezt a dicséretet?")) return;
        const updatedList = localPraises.filter(p => p.id !== idToDelete).map((item,index) => ({ ...item, order: index + 1}));
        setLocalPraises(updatedList);
    };

    const handleSaveChanges = () => {
        const updatedFormData = JSON.parse(JSON.stringify(formData));
        updatedFormData.praises = localPraises;
        handleSave(updatedFormData);
    };

    if (isLoading && !formData) return <div>Betöltés...</div>;

    return (
        <div>
            <div className="admin-page-header">
                <h1>Marketing / Dicséretek Kezelése</h1>
                <div>
                    {success && <span className="success-message">{success}</span>}
                    <button onClick={handleSaveChanges} className="save-button" disabled={isSaving}>
                        {isSaving ? 'Mentés...' : 'Változtatások Mentése'}
                    </button>
                </div>
            </div>
            
            <p className="page-description">Húzd a dicséreteket a kívánt sorrendbe. Ez a globális sorrend.</p>

            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="praises-list">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef} className="praise-list">
                            {localPraises.map((praise, index) => (
                                <Draggable key={praise.id} draggableId={praise.id} index={index}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={`praise-item ${snapshot.isDragging ? 'dragging' : ''}`} >
                                            <div className="praise-drag-indicator" style={{paddingTop: '10px', paddingRight: '15px'}}>
                                                <DragHandleIcon />
                                            </div>
                                            <div className="praise-content">
                                                <blockquote className="praise-quote-admin">“{praise.quote}”</blockquote>
                                                <cite className="praise-source-admin">— {praise.source}</cite>
                                            </div>
                                            <div className="praise-actions">
                                                <button onClick={() => handleDelete(praise.id)} className="action-button delete">Törlés</button>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    );
};

export default PraisesPage;